// Utility functions for data processing
// These functions perform calculations on data arrays without any external dependencies

export const calculateAverageMetrics = (data = [], view) => {
  if (!Array.isArray(data) || data.length === 0) {
    console.warn('Data is not an array or is empty:', data);
    return {
      averageStepCount: 0,
      averageWalkingTime: 0,
      averageStrideLength: 0,
      averageKneeRangeMotion: 0,
    };
  }

  let sumStepCount = 0, sumWalkingTime = 0, sumStrideLength = 0, sumKneeRangeMotion = 0;
  let count = 0;

  if (view === 'year') {
    data.forEach(month => {
      if (month.valid_days > 0) {
        sumStepCount += month.step_count;
        sumWalkingTime += month.minutes;
        sumStrideLength += month.step_length * month.valid_days;
        sumKneeRangeMotion += month.romKnee * month.valid_days;
        count += month.valid_days;
      }
    });
  } else {
    data.forEach(item => {
      if (item.step_count !== 0 || item.minutes !== 0 || item.step_length !== 0 || item.romKnee !== 0) {
        sumStepCount += item.step_count;
        sumWalkingTime += item.minutes;
        sumStrideLength += item.step_length;
        sumKneeRangeMotion += item.romKnee;
        count++;
      }
    });
  }

  if (count === 0) {
    return { averageStepCount: 0, averageWalkingTime: 0, averageStrideLength: 0, averageKneeRangeMotion: 0 };
  }

  return {
    averageStepCount: Math.round(sumStepCount / count),
    averageWalkingTime: Math.round(sumWalkingTime / count),
    averageStrideLength: parseFloat((sumStrideLength / count).toFixed(2)),
    averageKneeRangeMotion: parseFloat((sumKneeRangeMotion / count).toFixed(2)),
  };
};

export const getTotalStepCounts = (data) => {
    const stepCounts = data.map((d) => d.step_count);
    return stepCounts.reduce((a, b) => a + b, 0);
}

export const getTotalValidDays = (data, view) => {
    if (view === "year") {
        return data.reduce((acc, curr) => acc + curr.valid_days, 0);
    }
    return data.filter(d => d.step_count > 0).length;
}